<template>
  <span>
    <el-popover
      v-model="visible"
      placement="bottom-start"
      width="600"
      popper-class="launchFilter"
      trigger="click"
    >
      <div>
        <header>
          <div class="column">
            <strong>效果指标</strong>
            <div>
              <el-radio v-model="period" label="1">花费</el-radio>
              <el-radio v-model="period" label="2">曝光次数</el-radio>
              <el-radio v-model="period" label="3">点击次数</el-radio>
              <el-radio v-model="period" label="3">点击率</el-radio>
              <el-radio v-model="period" label="3">转化率</el-radio>
              <el-radio v-model="period" label="3">转化成本</el-radio>
            </div>
          </div>
          <div class="column">
            <strong>推广目标</strong>
            <div>
              <el-radio v-model="period" label="1">推广品牌活动</el-radio>
              <el-radio v-model="period" label="1">推广门店</el-radio>
              <el-radio v-model="period" label="1">收集销售线索</el-radio>
              <el-radio v-model="period" label="1">推广商品</el-radio>
            </div>
            <div>
              <el-radio v-model="period" label="1">移动应用推广·Android应用</el-radio>
              <el-radio v-model="period" label="1">移动推广·IOS应用</el-radio>
              <el-radio v-model="period" label="1">派发优惠劵</el-radio>

            </div>
            <div>
              <el-radio v-model="period" label="1">推广公众号</el-radio>
              <el-radio v-model="period" label="1">推广小游戏</el-radio>
              <el-radio v-model="period" label="1">微信支付代金劵</el-radio>
              <el-radio v-model="period" label="1">推广视频号</el-radio>
            </div>
          </div>
          <div class="column">
            <strong>投放位置</strong>
            <div>
              <el-radio v-model="period" label="1">公众号文章底部</el-radio>
              <el-radio v-model="period" label="1">公众号文章视频贴片</el-radio>
              <el-radio v-model="period" label="1">公众号互选广告</el-radio>
            </div>
            <div>
              <el-radio v-model="period" label="1">公众号文章中部</el-radio>
              <el-radio v-model="period" label="1">小程序banner广告</el-radio>
              <el-radio v-model="period" label="1">激励式广告</el-radio>
              <el-radio v-model="period" label="1">小程序插屏广告</el-radio>
            </div>
            <div>
              <el-radio v-model="period" label="1">展示banner图片</el-radio>
              <el-radio v-model="period" label="1">优雅横版大图</el-radio>
              <el-radio v-model="period" label="1">沉浸式横版视频</el-radio>
              <el-radio v-model="period" label="1">横版聚合格子广告</el-radio>
            </div>
            <div>
              <el-radio v-model="period" label="1">支付订单详情页</el-radio>
            </div>
          </div>
          <div class="column">
            <strong>购买方式</strong>
            <div>
              <el-radio v-model="period" label="1">合约购买</el-radio>
              <el-radio v-model="period" label="1">竞价购买</el-radio>
            </div>
          </div>
        </header>
        <main>
          <div class="column">
            <strong>创建日期</strong>
            <div>
              <el-radio v-model="period" label="1">全部</el-radio>
              <el-radio v-model="period" label="1">最近30天</el-radio>
              <el-radio v-model="period" label="1">最近三个月</el-radio>
              <el-radio v-model="period" label="1">最近半年</el-radio>
              <el-radio v-model="period" label="1">最近一年</el-radio>
            </div>
            <div>
              <el-radio v-model="period" label="1">自定义日期</el-radio>
            </div>
          </div>
          <div class="column">
            <strong>状态</strong>
            <div>
              <el-radio v-model="period" label="1">全部</el-radio>
              <el-radio v-model="period" label="1">投放中</el-radio>
              <el-radio v-model="period" label="1">待投放</el-radio>
              <el-radio v-model="period" label="1">已暂停</el-radio>
              <el-radio v-model="period" label="1">审核中</el-radio>
              <el-radio v-model="period" label="1">待排期</el-radio>
            </div>
            <div>
              <el-radio v-model="period" label="1">未通过</el-radio>
              <el-radio v-model="period" label="1">已结束</el-radio>
              <el-radio v-model="period" label="1">已锁量</el-radio>
              <el-radio v-model="period" label="1">排期中</el-radio>
              <el-radio v-model="period" label="1">创建中</el-radio>
            </div>
            <div>
              <el-radio v-model="period" label="1">保障性结束</el-radio>
              <el-radio v-model="period" label="1">已失效</el-radio>
              <el-radio v-model="period" label="1">已结束</el-radio>
              <el-radio v-model="period" label="1">待开播</el-radio>
              <el-radio v-model="period" label="1">已取消</el-radio>
            </div>
            <div>
              <el-radio v-model="period" label="1">确认合作中</el-radio>
              <el-radio v-model="period" label="1">合作未达成</el-radio>
              <el-radio v-model="period" label="1">文章编辑中</el-radio>
              <el-radio v-model="period" label="1">文章待确认</el-radio>
            </div>
          </div>
          <div class="column-outside">
            <strong>智能优化保障状态</strong>
            <div>
              <el-radio v-model="period" label="1">成本保障中</el-radio>
              <el-radio v-model="period" label="1">保障核实中</el-radio>
              <el-radio v-model="period" label="1">已赔付</el-radio>
              <el-radio v-model="period" label="1">不满足保障</el-radio>
              <el-radio v-model="period" label="1">保障已结束</el-radio>
            </div>
            <div>
              <el-radio v-model="period" label="1">自定义日期</el-radio>
            </div>
          </div>
          <div class="column-outside">
            <strong>商品广告</strong>
            <div>
              <el-radio v-model="period" label="1">是</el-radio>
              <el-radio v-model="period" label="1">否</el-radio>
            </div>
          </div>
        </main>
        <footer>
          <el-button type="text" style="color: #333" @click="visible = false">取消</el-button>
          <el-button type="text" style="color: rgb(14,194,101)" @click="visible = false">应用</el-button>
        </footer>
      </div>
      <i slot="reference" class="el-icon-message-solid" />
    </el-popover>
  </span>
</template>

<script>
export default {
  name: 'LaunchFilter',
  data() {
    return {
      period: '',
      visible: false
    }
  }
}
</script>

<style>
  .launchFilter {
    padding: 0;
  }
</style>
<style scoped lang="less">
  header {
    border-bottom: 1px solid #EBEEF5;
    margin: 20px 20px 0 20px;
    padding-bottom: 10px;
    /deep/ .el-radio__inner {
      border-radius: 0;
    }
  }
  main {
    margin: 20px 20px 0 20px;
    padding-bottom: 10px;
  }
  footer {
    border-top: 1px solid #EBEEF5;
    padding: 10px 0 10px 0;
    display: flex;
    justify-content: right;
    .el-button {
      margin-right: 20px;
    }
  }
  .column {
    margin: 10px 0 10px 0;
    strong {
      margin-bottom: 5px;
    }
    .el-radio {
      min-width: 70px;
      margin-right: 10px;
    }
  }
  .column-outside {
    margin: 10px 0 10px 0;
    .el-radio {
      margin-right: 10px;
    }
    /deep/ .el-radio__inner {
      border-radius: 0;
    }
  }
</style>
